export const VIEW_W = 720;
export const VIEW_H = 1280;
